<template>
  <div class="options-row row BoxStyle" :class="[{'RemoveControl':clicked!==-1}]">
    <div class="col-12 text-center HeaderPositionQuestion">
      <h1 id="questionTitle" class="redText main-title" :class="['fade', {'fade-in':question}]">
        Find the character for ‘five’
        <img
          class="x-btn"
          style="cursor: pointer;float: right"
          @mouseenter="buttonHover"
          :src="require(`@/assets/img/Question.png`)"
          alt
          @click="closeClick"
        />
      </h1>
    </div>
    <div
      class="col-4 mx-2 mt-3 fade options image"
      style="transition: all 0.6s ease!important;"
      v-for="(i, index) in list"
      :key="i"
      :style="{border:clicked !== -1 || ShowMe?'unset':''}"
      :class="[{'fade-in':images,'active': active === i,
                                'RemoveAnimation':clicked !== -1 &&  clicked !== index ,
                  'clicked hinted': clicked === index && ShowMe!== true,
                  'move-right': ( ( (clicked===2 && index===1) || (clicked===1 && index===2 ) || (clicked===0 && index===2 ) ) && ShowMe!== true ),
                  'move-left': ( ( (clicked===2 && index===0) || (clicked===1 && index===0 ) || (clicked===0 && index===1 ) ) && ShowMe!== true),
                  },
                   `index-${list.length===1?1:index}`,
                    `${ControlToShow(index)}`,
                   `l2q4option-${i}`]"
    >
      <template v-if="index===1">
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-else>
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
        />
      </template>
      <template v-if="i===2">
        <img
          src="../../../assets/img/sign.gif"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            position:'absolute',
            left: '-2%',
            top: '14%',
            width: '10%',
            height: '65%',
            zIndex: '99'
          }"
        />
        <img
          src="../../../assets/img/sign.gif"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            position:'absolute',
            left: '14%',
            top: '40%',
            width: '10%',
            height: '38%',
            zIndex: '99'
          }"
        />
      </template>

      <template v-if="i===3">
        <img
          src="../../../assets/img/sign.gif"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            position:'absolute',
            left: '14%',
            top: '40%',
            width: '10%',
            height: '38%',
            zIndex: '99'
          }"
        />
      </template>
      <template v-if="i===2 && pregress">
        <img alt="dash.png" src="./images/2-up.png" class="fork fork1" />
        <img alt="dash.png" src="./images/2-center.png" class="fork fork2" />
        <img alt="dash.png" src="./images/2-down.png" class="fork fork3" />
        <img alt="dash.png" src="./images/2-center-grey.png" class="fork fork4" />
        <img alt="dash.png" src="./images/2-right-grey.png" class="fork fork5" />
        <span class="fork fork6">1</span>
        <span class="fork fork7">2</span>
        <span class="fork fork8">3</span>
      </template>
      <template v-if="i===3 && pregress">
        <img alt="dash.png" src="./images/3-up.png" class="part part1" />
        <img alt="dash.png" src="./images/3-center-red.png" class="part part2" />
        <img alt="dash.png" src="./images/3-down.png" class="part part3" />
        <img alt="dash.png" src="./images/3-center.png" class="part part4" />
        <img alt="dash.png" src="./images/3-right-red.png" class="part part5" />
      </template>
    </div>

    <div
      style="bottom: 10px;position: absolute;padding: 10px "
      :class="{'fade hints-row': true, 'fade-in':textBoxEnable===1, 'fade-out':textBoxEnable===2 }"
    >
      <div
        class="col-12 p-0"
        v-for="(i) in list"
        :key="i"
        :class="[{'active': active === i, }]"
        style="padding: 0"
      >
        <div v-if="textBox[i] !== ''" class="pt-5">
          <div class="pt-5 mt-4">
            <div v-if="textBox[i] !== ''" class="text-box py-3 px-3 align-center text-center">
              <p class="mb-0 mr-3">{{textBox[i]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question3",

  data() {
    return {
      pregress: false,
      wrongShow: false,
      ShowMe: false,
      textBoxEnable: 0,
      closeTextEnable: false,
      images: false,
      question: false,
      active: 0,
      clicked: -1,
      list: [1, 2, 3],
      textBox: {
        1: "",
        2: "",
        3: ""
      },
      hints: {
        1: "",
        2: `Let’s count how many strokes we have here… Maybe we need more than just three?`,
        3: `The character for five is indeed made up of just 4 strokes. However one stroke has a turn, which makes it look like 5 strokes...`
      },
      hinted: false,
      mouse_over: "/sound/new mouse over.wav"
    };
  },
  props: {
    playSound: {
      type: Function
    },
    shuffle: {
      type: Function
    },
    finish: {
      type: Function
    },
    buttonHover: {
      type: Function
    }
  },
  mounted() {
    this.images = false;
    this.list = this.shuffle(this.list);

    this.playSound(require("./sounds/3-4.wav"));
    setTimeout(() => {
      this.question = true;

      setTimeout(() => {
        this.images = true;
      }, 2000);
      setTimeout(() => {
        this.closeTextEnable = true;
        // this.playSound("/sound/textbox shows.wav");
        setTimeout(() => {
          this.closeTextEnable = false;
        }, 5000);
      }, 3000);
    }, 500);
  },
  methods: {
    closeClick() {
      if (this.ShowMe === true || this.pregress === true) {
        return;
      }
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.pregress = true;
      this.ShowMe = false;
      this.playSound("/sound/button click.wav").then(() => {
        setTimeout(() => {
          this.textBox = {
            1: "",
            2: "",
            3: ""
          };

          setTimeout(() => {
            this.clicked = this.list.indexOf(2);

            setTimeout(() => {
              this.wrongShow = true;
            }, 1300);
            this.textBox[2] = JSON.parse(JSON.stringify(this.hints[2]));
            this.hinted = true;
            this.playSound("/sound/textbox shows.wav");
            this.playSound(require("./sounds/3-42.wav")).then(() => {
              this.wrongShow = false;
              setTimeout(() => {
                this.wrongShow = true;
              }, 400);
              setTimeout(() => {
                this.playSound("/sound/textbox shows.wav");
                this.clicked = this.list.indexOf(3);

                this.textBox[2] = "";
                this.textBox[3] = JSON.parse(JSON.stringify(this.hints[3]));
                this.playSound(require("./sounds/3-43.wav")).then(() => {
                  setTimeout(() => {
                    this.wrongShow = false;
                    this.playSound("/sound/correct answer.wav");
                    this.textBox = {
                      1: "",
                      2: "",
                      3: ""
                    };
                    this.list = [3, 1, 2];
                    this.clicked = this.list.indexOf(1);

                    setTimeout(() => {
                      this.hinted = false;
                      // this.start = false
                      // this.end = false
                      this.textBoxEnable = 0;
                      this.list = this.shuffle(this.list);
                      this.pregress = false;
                      this.active = 0;
                      this.ShowMe = false;
                      this.clicked = -1;
                    }, 3000);
                  }, 3000);
                });
              }, 5000);
            });

            this.textBoxEnable = 1;
          }, 50);
        });
      }, 1000);
    },
    mouseleave() {
      this.active = 0;
    },
    mouseover(i) {
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.active = i;
      this.playSound(this.mouse_over);
    },
    ControlToShow(i) {
      if (this.ShowMe) {
        if (i === 0) {
          return "RemoveAnimation";
        }
        if (i === 2) {
          return "RemoveAnimation";
        }
      } else {
        return "Scale1";
      }
      return "";
    },
    closeTextBox() {
      this.textBoxEnable = 2;
      this.hinted = false;
      setTimeout(() => {
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.textBoxEnable = 0;
        this.clicked = -1;
      }, 1000);
    },
    imgClick(i, index) {
      if (this.clicked !== -1 || this.ShowMe || this.pregress === true) {
        return;
      }
      this.pregress = true;

      setTimeout(() => {
        this.hinted = false;
        this.clicked = index;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        if (i === 1) {
          setTimeout(() => {
            this.pregress = false;
            this.closeTextBox();
          }, 3000);
          this.playSound("/sound/correct answer.wav");
          this.finish();
        } else {
          setTimeout(() => {
            this.wrongShow = true;
          }, 1900);

          setTimeout(() => {
            this.wrongShow = false;
          }, 6000);
          this.playSound("/sound/highlight.wav");

          this.clicked = index;
          if (i === 2) {
            this.textBox[i] = this.hints[i];
            this.playSound(require("./sounds/3-42.wav")).then(() => {
              setTimeout(() => {
                this.clicked = -1;
                this.textBox = {
                  1: "",
                  2: "",
                  3: ""
                };
                this.pregress = false;
              }, 7500);
            });
          } else {
            setTimeout(() => {
              this.textBox[i] = this.hints[i];
              this.playSound(require("./sounds/3-43.wav")).then(() => {
                this.clicked = -1;
                this.textBox = {
                  1: "",
                  2: "",
                  3: ""
                };
                this.pregress = false;
              });
            }, 2500);
          }
          setTimeout(() => {
            this.playSound("/sound/textbox shows.wav");
            this.textBoxEnable = 1;
          }, 1000);
          setTimeout(() => {}, 1000);
          if (index != 1) {
            console.log(index);
          }
        }
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.l2q4option-2 {
  .fork {
    position: absolute;
    top: 15%;
    left: 70%;
    width: 55%;
    opacity: 0;
    transition: all 1s ease;
    height: 70%;
  }

  .fork1,
  .fork2,
  .fork3 {
    width: 0%;
  }
  .fork1 {
    z-index: 100;
  }
  .fork2 {
    z-index: 40;
  }
  .fork4 {
    z-index: 50;
  }

  .fork4,
  .fork5 {
    height: 0%;
  }

  .fork4 {
    top: 30%;
    left: 68%;
  }
  .fork5 {
    top: 52%;
    left: 68%;
  }

  .fork6,
  .fork7,
  .fork8 {
    font-weight: bold;
    color: #00b050;
  }

  .fork6 {
    top: 24%;
  }

  .fork7 {
    top: 46.5%;
    left: 73%;
  }

  .fork8 {
    top: 70.5%;
    left: 65%;
  }

  .v-image {
    left: 0;

    /*opacity: 0;*/
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: left 2s;
      left: -50%;

      /*opacity: 0;*/
    }

    .fork {
      animation: fadeIn 1s 4s forwards;
    }

    .fork1 {
      transition-delay: 4s;
    }

    .fork6 {
      animation: fadeIn 1s 5s forwards;
    }
    .fork7 {
      animation: fadeIn 1s 6s forwards;
    }
    .fork8 {
      animation: fadeIn 1s 7s forwards;
    }

    .fork2 {
      transition-delay: 5s;
    }

    .fork3 {
      transition-delay: 6s;
    }

    .fork4 {
      transition-delay: 7s;
      top: 15%;
    }

    .fork5 {
      transition-delay: 8s;
      top: 15%;
    }

    .fork1,
    .fork2,
    .fork3 {
      width: 53%;
    }

    .fork4,
    .fork5 {
      height: 70%;
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.l2q4option-3 {
  .part {
    position: absolute;
    top: 16%;
    left: 70%;
    height: 70%;
    width: 53%;
    opacity: 0;
    transition: all 1s;
  }

  .part1,
  .part2,
  .part3 {
    width: 0%;
  }

  .part4,
  .part5 {
    height: 0%;
  }

  .part4 {
    top: 29%;
  }
  .part5 {
    top: 52%;
  }

  .v-image {
    left: 0;

    /*opacity: 0;*/
  }

  .v-image {
    left: unset;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: all 2s;
      left: -50%;
      /*opacity: 0;*/
    }

    .part {
      animation: fadeIn 1s 4s forwards;
    }

    .part1 {
      transition-delay: 4s;
    }

    .part2 {
      transition-delay: 5s;
    }

    .part3 {
      transition-delay: 7s;
    }

    .part1,
    .part2,
    .part3 {
      width: 53%;
    }

    .part4 {
      transition-delay: 8s;
      top: 15%;
      height: 70%;
    }

    .part5 {
      transition-delay: 6s;
      height: 72%;

      top: 14.5%;
    }
  }
}
</style>